import { HelpOutlineIcon } from 'tuui';
import { TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './uploadImageTooltip.module.scss';

export const UploadImageTooltip = () => {
    return (
        <div className={styles['help-tooltip']}>
            <Tooltip position={TOOLTIP_POSITION.TOP} arrow>
                <FormattedMessage
                    id="creative.editor.tab.aiGenerated.imageToMotion.upload.tooltip"
                    defaultMessage="For best results, use high-quality images with a 1280:720 ratio and clear, recognizable subjects."
                />
            </Tooltip>
            <HelpOutlineIcon className={styles['help-icon']} />
        </div>
    );
};
